import { lazy, Suspense, useMemo, type CSSProperties } from 'react'
import { BlockComponentFactory } from '../BlockFactory'
import { useBlockEngine } from '../BlockEngineContext'
import { PdfBlockProps } from './block-props.types'
import { LABEL_BOLD_FONT_STYLE } from '../../constants'
import { LabelBlock } from './LabelBlock'
import { toCSSSize } from './block-utils'

const PdfViewer = lazy(() =>
    import('../../../components/PdfViewer/PdfViewer').then(module => ({
        default: module.PdfViewer,
    }))
)

export const PdfBlockComponent = BlockComponentFactory.createBlockComponent<PdfBlockProps>(
    props => {
        const {
            src,
            label,
            infoText,
            width,
            height,
            visibility = 'visible',
            disabled = false,
            style,
        } = props

        const isEditable = useBlockEngine().blockEngine.getEditableSignal().value
        const containerHeight = toCSSSize(height) ?? 'auto'

        const containerStyle: CSSProperties = useMemo(
            () => ({
                ...style,
                display: visibility === 'hidden' ? 'none' : 'flex',
                flexDirection: 'column',
                gap: '8px',
                width: toCSSSize(width) ?? '100%',
                maxWidth: '100%',
                minHeight: '200px',
                height: containerHeight,
            }),
            [style, visibility, width, containerHeight]
        )

        return (
            <div style={containerStyle}>
                <LabelBlock label={label} infoText={infoText} labelStyle={LABEL_BOLD_FONT_STYLE} />
                <Suspense fallback={null}>
                    <PdfViewer
                        src={src}
                        disabled={!isEditable || disabled}
                        height={containerHeight}
                    />
                </Suspense>
            </div>
        )
    }
)
